import { Footer } from "@excalidraw/excalidraw/index";
import { Tooltip } from "@excalidraw/excalidraw/components/Tooltip";
import React from "react";

import { isExcalidrawPlusSignedUser } from "../app_constants";

import { DebugFooter, isVisualDebuggerEnabled } from "./DebugCanvas";
import { ExcalidrawPlusAppLink } from "./ExcalidrawPlusAppLink";

export const AppFooter = React.memo(
  ({ onChange }: { onChange: () => void }) => {
    return (
      <Footer>
        <div
          style={{
            display: "flex",
            gap: ".5rem",
            alignItems: "center",
          }}
        >
          <a
            href="https://drive.createstudio.app/"
            target="_blank"
            rel="noreferrer"
            className="plus-button drive-data-button"
            aria-label="Open MyData drive"
          >
            <Tooltip
              label="You can download or delete your data from drive."
              long={true}
            >
              <span>MyData</span>
            </Tooltip>
          </a>
        </div>
      </Footer>
    );
  },
);
